import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import { ChevronDown } from 'lucide-react-native';

export default function DeveloperToolsAccordion({ children }: { children?: React.ReactNode }) {
  const { profile } = useAuth();
  const { theme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const hasContent = React.Children.count(children) > 0;

  const isOwnerDemoMode =
    (profile as any)?.owner_demo_mode === true || (profile as any)?.is_owner_demo_mode === true;
  const isScreenshotMode =
    (profile as any)?.screenshot_mode === true || (profile as any)?.is_screenshot_mode === true;

  // Allow dev tools in dev mode OR for admin users in production
  const isAdmin = (profile as any)?.is_admin === true;

  if ((!__DEV__ && !isAdmin) || isOwnerDemoMode || isScreenshotMode) {
    return null;
  }

  return (
    <View style={[styles.section, { backgroundColor: theme.colors.surface }]}>
      <TouchableOpacity
        style={[styles.headerRow, { borderBottomColor: theme.colors.border }]}
        onPress={() => setIsOpen(current => !current)}
        activeOpacity={0.8}
      >
        <Text style={[styles.title, { color: theme.colors.text }]}>Developer Tools</Text>
        <ChevronDown
          size={18}
          color={theme.colors.textSecondary}
          style={[styles.chevron, isOpen && styles.chevronOpen]}
        />
      </TouchableOpacity>

      {isOpen && (
        <View style={styles.body}>
          {hasContent ? (
            children
          ) : (
            <Text style={[styles.placeholder, { color: theme.colors.textSecondary }]}>
              No developer actions registered on this branch.
            </Text>
          )}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    borderRadius: 2,
    padding: 16,
    marginBottom: 16,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 12,
    borderBottomWidth: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: '900',
  },
  chevron: {
    transform: [{ rotate: '-90deg' }],
  },
  chevronOpen: {
    transform: [{ rotate: '0deg' }],
  },
  body: {
    marginTop: 12,
  },
  placeholder: {
    fontSize: 14,
  },
});
